export default function reducer(state = {
  sucursales: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_SUCURSALES": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}